"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Options = /** @class */ (function () {
    function Options(_rule, src) {
        src = src || {};
        this.wordBoundary = src.wordBoundary != null ? src.wordBoundary : false;
    }
    return Options;
}());
exports.Options = Options;
//# sourceMappingURL=options.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/prh/lib/options.js
// module id = 1015
// module chunks = 0